import { render } from "./ImageImpulseSkeleton.vue?vue&type=template&id=79dd2736&scoped=true"
import script from "./ImageImpulseSkeleton.vue?vue&type=script&lang=js"
export * from "./ImageImpulseSkeleton.vue?vue&type=script&lang=js"

import "./ImageImpulseSkeleton.vue?vue&type=style&index=0&id=79dd2736&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dd2736"]])

export default __exports__